import React from 'react';
import './App.css';
import Navbar from './component/Navbar';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Home from './pages/Home';
import UpdateLicense from './pages/UpdateLicense';
import S3Uploads from './pages/S3Uploads';
import Extras from './pages/Extras';
import SSOPage from './pages/SSOPage'
import Login from './pages/Login';
import CustomerDetails from './pages/CustomerDetails';


function App() {
  let user =   localStorage.user;
  return (
    <div>
      <Router basename="/build" >
        <Navbar />
        <Switch>
          <Route path='/' exact component={ user === undefined ? SSOPage : Home } />
          <Route path='/sso' component={Login} />
          <Route path='/updatelicense' component={UpdateLicense} />
          <Route path='/s3uploads' component={S3Uploads} />
          <Route path='/extras' component={Extras} />
          <Route path='/details' component={ CustomerDetails }/>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
